import React, { ReactNode } from 'react';
import { cn } from '../utils/classUtils';

interface InstructionCardProps {
  title: string;
  instructions: ReactNode;
  isSelected?: boolean;
  onClick?: () => void;
}

const InstructionCard: React.FC<InstructionCardProps> = ({
  title,
  instructions,
  isSelected = false,
  onClick,
}) => {
  return (
    <div
      className={cn(
        'flex min-w-[120px] py-4 px-6 flex-col gap-2 self-stretch rounded-lg border cursor-pointer',
        isSelected
          ? 'bg-reskin-regent-100 border-reskin-primary-blue'
          : 'bg-white border-reskin-regent-400',
      )}
      onClick={onClick}
    >
      <div className='flex flex-col justify-center items-center gap-2 self-stretch'>
        <div className='text-center font-inter-semibold text-lg leading-6'>
          {title}
        </div>
        <div className='text-center font-inter-light text-sm leading-[18px]'>
          {instructions}
        </div>
      </div>
    </div>
  );
};

export default InstructionCard;
